import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import useRouteParam from '../../hooks/useRouteParam'
import ColumnBtnCard from '../atoms/columnBtnCard'
import ColumnH1 from '../atoms/columnH1'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-list-link {
    position: absolute;
    top: 9px;
    right: 2px;

    &:before {
      display: block;
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: 7px;
      left: -14px;
      border-left: 8px solid #3ec7b3;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
    }
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .list-btn-wrap {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    a {
      border-radius: 25vh;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      background: #19ba9b;
      border: solid 2px #19ba9b;
      width: 200px;
      height: 50px;

      &:hover {
        opacity: 1;
        background: #ffffff;
        color: #3ec7b3;
        text-decoration: underline solid rgba(255, 255, 255, 0);
      }
    }
  }
`

/**
 * 最新記事カードセット
 * TODO 川上申し送り事項：ここでは、新着記事6件が表示される予定です
 * @constructor
 */
const ColumnNewCards = () => {
  const routeParam = useRouteParam('/column/details/C0104/')
  const routeParam2 = useRouteParam('/column/details/C0103/')
  const routeParam3 = useRouteParam('/column/details/C0102/')
  const routeParam4 = useRouteParam('/column/details/C0100/')
  const routeParam5 = useRouteParam('/column/details/C0099/')
  const routeParam6 = useRouteParam('/column/details/C0098/')

  return (
    <Wrapper>
      <ColumnH1 label="最新コラム" />
      <section>
        <ColumnBtnCard
          href={routeParam}
          imgId="c0104.jpg"
          label="サービス残業とは？その問題点と対策について解説！"
          date="2026.06.24"
        />
        <ColumnBtnCard
          href={routeParam2}
          imgId="c0103.jpg"
          label="パートタイム・有期雇用労働法の改正について"
          date="2026.06.03"
        />
        <ColumnBtnCard
          href={routeParam3}
          imgId="c0102.jpg"
          label="高年齢者雇用安定法改正について。企業の実務対応策とは？"
          date="2026.04.17"
        />
        <ColumnBtnCard
          href={routeParam4}
          imgId="c0100.jpg"
          label="副業・兼業における労務管理について。リスクと対策を紹介"
          date="2026.03.23"
        />
        <ColumnBtnCard
          href={routeParam5}
          imgId="c0099.jpg"
          label="労働基準監督署について。調査内容と対応法とは？"
          date="2026.02.20"
        />
        <ColumnBtnCard
          href={routeParam6}
          imgId="c0098.jpg"
          label="勤務時間の切り捨て（丸め）とは？そのメリットとデメリットを探る"
          date="2026.01.15"
        />
        {/* <ColumnBtnCard
          href={routeParam6}
          imgId="c0092.jpg"
          label="勤怠管理のワークフローはシステム化できる！メリットや選び方を解説"
          date="2024.03.21"
        /> */}
      </section>
      <div className="list-btn-wrap">
        <Link className="list" to={useRouteParam('/column/list/')}>
          記事一覧
        </Link>
      </div>
    </Wrapper>
  )
}

export default ColumnNewCards
